<template>
    <el-container class="gayBG naire-page el-layout">
        <!-- start 类型  start-->
        <el-aside width="300px" class="whiteBG inner-box fixed-naire-aside" :style="{'left':this.$store.state.isCollapse ? '80px':'220px'}">
            <h4 style="font-size: 18px; margin: 10px 0;text-align: left;">选项</h4>
            <el-collapse v-model.trim="activeNames" class="collapse-slide">
                <el-collapse-item title="常用字段" name="1">
                    <div class="menu-box">
                        <div v-for="item in fixedList" :key="item.name" @click.stop="() => addConfig(item)">
                            <v-icon :name="item.icon"></v-icon>
                            {{item.name}}
                        </div>
                    </div>
                </el-collapse-item>

                <el-collapse-item title="可选类型" name="2">
                    <div class="menu-box">
                        <div v-for="item in typeList" :key="item.type" @click.stop="() => addConfig(item)">
                            <v-icon :name="item.icon"></v-icon>
                            {{item.title}}
                        </div>
                    </div>

                </el-collapse-item>
            </el-collapse>
        </el-aside>
        <!-- end 类型  end-->
        <!-- start 内容  start-->
        <el-container class="whiteBG" :style="{'margin-left':this.$store.state.isCollapse ? '310px':'330px'}">
            <div class="whiteBG inner-box " style="font-size: 20px; min-width: 60vw;">
                <h4 style="font-size: 20px; margin: 10px 0;cursor: pointer;" @click.stop="() => openNaire()">{{naireInfo.title}}
                    <i class="el-icon-edit" style="color: #ddd;margin-left: 5px"></i>
                </h4>
                <p style="color: #666;font-size: 16px;">{{naireInfo.describe}}</p>
                <div v-for="(item, index) in originData" :key="item.uuid">
                    <one-form :row="item" :rank="index+1" @editForm="editForm" @delForm="delConfig" @moveAction="moveAction"></one-form>
                    <one-naire :editOne="editOne" :uuid="item.uuid" @editForm="editConfig" @cancelDo="editForm"></one-naire>
                </div>
                <!-- <el-button type="primary"  style="margin-top: 20px"  @click="()=> goBack()">完成编辑</el-button> -->
            </div>
        </el-container>
        <!-- end 内容  end-->
        <!-- end 内容  end-->
        <el-dialog :title="'修改问卷--'+naireInfo.title" :visible.sync="dialogTip" width="400px">
            <el-form :inline="dialogTip" :rules="naireRules" :model="editNaire" ref="editNaire">
                <el-form-item label="问卷标题" prop="title">
                    <el-input v-model.trim="editNaire.title" autocomplete="off" style="width: 260px"></el-input>
                </el-form-item>
                <el-form-item label="问卷描述" prop="describe">
                    <el-input
                        type="textarea"
                        autosize
                        v-model.trim="editNaire.describe"
                        autocomplete="off"
                        style="width: 260px"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click.stop="dialogTip = false">取 消</el-button>
                <el-button type="primary" @click.stop="() => editNaireDoing()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- end 内容  end-->
    </el-container>
</template>
<script>
    import OneForm from '@/components/naire/OneForm.vue'
    import EditNaire from '@/components/naire/EditNaire.vue'
    import { getNaireDetailAPI, addQuestionAPI, editQuestionAPI, delQuestionAPI, editNaireAPI, getInitNaireAPI } from '@/utils/service'
    import { cloneObj } from '@/utils/tool'
    export default {
        inject: ["reload"],
        components: {
            "one-form": OneForm,
            "one-naire": EditNaire
        },
        data() {
            return {
                dialogTip: false,
                editNaire: {},
                uuid: "",
                activeNames: ['1', '2'],
                originData: [],
                naireInfo: {},
                editOne: {},
                fullLoading: null,
                fixedList: [
                    { name: "姓名", icon: "user", type: "input", title: "您的姓名是？" },
                    { name: "性别", icon: "anchor", type: "radio", title: "您的性别是？", data: ["男", "女"] },
                    { name: "职业", icon: "trello", type: "input", title: "您的职业是？" },
                    { name: "行业", icon: "trending-up", type: "input", title: "您的行业是？" },
                ],
                typeList: [
                    { title: "输入框", icon: "edit", type: "input" },
                    { title: "单选", icon: "disc", type: "radio", data: ['标签一', '标签二'] },
                    { title: "多选", icon: "check-square", type: "checkBox", data: ['标签一', '标签二'] }
                ],
                naireRules: {
                    title: [
                        { required: true, message: '请输入问卷标题', trigger: 'blur' },
                        { min: 2, message: '请输入至少2位的问卷标题', trigger: 'blur' },
                        { max: 20, message: '请输入至多20位的问卷标题', trigger: 'blur' }
                    ],
                    describe: [
                        { required: true, message: '请输入问卷描述', trigger: 'blur' },
                        { min: 2, message: '请输入至少2位的问卷描述', trigger: 'blur' },
                        { max: 80, message: '请输入至多80位的问卷描述', trigger: 'blur' }
                    ],
                }
            }
        },
        created() {
            // this.uuid = this.$store.state.naireUuid
            this.fullLoading = this.$loading({
                lock: true,
                background: 'rgba(0, 0, 0, 0.7)'
            })
            getInitNaireAPI()
                .then(({ data }) => {
                    this.uuid = data.data.uuid
                    let result = cloneObj(data.data)
                    this.originData = result.rows
                    this.naireInfo = { title: result.title, describe: result.describe, uuid: result.uuid }
                    this.fullLoading.close()
                })
                .catch(({ response }) => {
                    this.fullLoading.close()
                    this.$message.error(response.data.msg)

                })

            this.$store.commit('editCollapse', false)
        },
        methods: {
            openNaire() {
                this.editNaire = cloneObj(this.naireInfo)
                this.dialogTip = true
            },
            editNaireDoing() {
                this.$refs['editNaire'].validate((valid) => {
                    if (valid) {
                        this.fullLoading = this.$loading({
                            lock: true,
                            background: 'rgba(0, 0, 0, 0.7)'
                        })
                        editNaireAPI(this.editNaire)
                            .then(() => {
                                this.$message.success("问卷修改成功")
                                this.reload()
                            })
                            .catch(({ response }) => {
                                this.$message.error(response.data.msg)
                                this.fullLoading.close()
                            })
                    }
                })

            },
            getConfig() {
                getNaireDetailAPI({ uuid: this.uuid })
                    .then(({ data }) => {
                        let result = cloneObj(data.data)
                        this.originData = result.rows
                        this.naireInfo = { title: result.title, describe: result.describe }
                        this.fullLoading.close()
                    })
                    .catch(({ response }) => {
                        this.fullLoading.close()
                        this.$message.error(response.data.msg)

                    })
            },
            editForm(data) {
              console.log(data,this.editOne)
                if (data.uuid === this.editOne.uuid) {
                    this.editOne = {}
                } else {
                    this.editOne = cloneObj(data)
                }
            },
            addConfig(addInfo) {
              this.fullLoading = this.$loading({
                lock: true,
                background: 'rgba(0, 0, 0, 0.7)'
              })
                let newData = cloneObj(this.originData)
                const len = newData.length
                addInfo.require = true
                addInfo.sort = len > 0 ? newData[len - 1].sort + 1 : 1
                addInfo.uuid = this.uuid
                addInfo.data = "[\"标签一\",\"标签二\"]"
                this.editOne = {}

                addQuestionAPI(addInfo)
                    .then(({ data }) => {
                        addInfo.uuid = data.data.uuid
                        this.$message.success("新增问题成功")
                        newData.push(addInfo)
                        this.originData = newData
                        this.fullLoading.close()
                    })
                    .catch(({ response }) => {
                        this.fullLoading.close()
                        this.$message.error(response.data.msg)
                    })
            },
            delConfig(data) {
                data.action = true
                this.fullLoading = this.$loading({
                    lock: true,
                    background: 'rgba(0, 0, 0, 0.7)'
                })
                delQuestionAPI(data)
                    .then(() => {
                        this.$message.success("删除问题成功")
                        this.reload()
                    })
                    .catch(({ response }) => {
                        this.fullLoading.close()
                        this.$message.error(response.data.msg)
                    })
            },
            editConfig(data) {
                this.fullLoading = this.$loading({
                    lock: true,
                    background: 'rgba(0, 0, 0, 0.7)'
                })
                editQuestionAPI(data)
                    .then(() => {
                        this.$message.success("修改问题成功")
                        this.reload()
                    })
                    .catch(({ response }) => {
                        this.fullLoading.close()
                        this.$message.error(response.data.message)
                    })
            },
            moveAction(data) {
                let result = cloneObj(this.originData)
                const { rank, action } = data
                let upData = {}
                let downData = {}
                if (action === "up") {
                    if (rank === 0) {
                        this.$message.error('当前选项已经在最前的，无法上移')
                        return false
                    }
                    this.fullLoading = this.$loading({
                        lock: true,
                        background: 'rgba(0, 0, 0, 0.7)'
                    })
                    const upNum = result[rank - 1].sort
                    const downNum = result[rank].sort
                    upData = result[rank]
                    upData.sort = upNum

                    downData = result[rank - 1]
                    downData.sort = downNum

                    this.moveConfig(upData, downData)
                    return true

                }
                if (action === "down") {
                    if (rank === result.length - 1) {
                        this.$message.error('当前选项已经在最后的，无法下移')
                        return false
                    }
                    this.fullLoading = this.$loading({
                        lock: true,
                        background: 'rgba(0, 0, 0, 0.7)'
                    })
                    upData = result[rank]
                    upData.sort = result[rank + 1].sort
                    downData = result[rank + 1]
                    downData.sort = result[rank].sort
                    this.moveConfig(upData, downData)
                }
            },
            moveConfig(upData, downData) {
                editQuestionAPI(upData).then(() => {
                    editQuestionAPI(downData)
                        .then(() => {
                            this.$message.success("问题排序成功")
                            this.reload()
                        })
                        .catch(({ response }) => {
                            this.$message.error(response.data.msg)
                            this.fullLoading.close()
                        })
                })
                    .catch(({ response }) => {
                        this.$message.error(response.data.msg)
                        this.fullLoading.close()
                    })
            },
            goBack() {
                this.$router.go(-1)
            }
        }
    }
</script>
<style>
    .naire-page {
        position: relative;
        display: flex;
    }

    .naire-page .menu-box {
        display: flex;
        flex-wrap: wrap;
    }

    .naire-page .menu-box>div {
        display: inline-flex;
        align-items: center;
        width: 50%;
        margin-bottom: 6px;
        cursor: pointer;
    }

    .naire-page .menu-box>div>svg {
        color: #0095FF;
        margin-right: 8px;
        width: 20px;
    }

    .fixed-naire-aside {
        position: fixed;
        top: 10vh;
        left: 0;

    }

    .naire-page .collapse-slide>.el-collapse-item:last-of-type>.el-collapse-item__wrap {
        border-bottom: none
    }
</style>